import { getTagManager } from '../api/tagManager';
export const getMostUsedPersons = async ({ count, page, minfaces, taggingEnrolled, isExplore }, logger) => {
    const urlParams = new URLSearchParams();
    count && urlParams.append('count', count.toString());
    page && urlParams.append('page', page);
    minfaces && urlParams.append('minfaces', minfaces);
    let data = [];
    let response = { nextPage: undefined };
    if (taggingEnrolled && isExplore) {
        try {
            response = await getTagManager(`persons?${urlParams.toString()}`, {}, logger);
            data = [...response?.persons];
        }
        catch (error) {
            data = [];
        }
    }
    return {
        data,
        hasNextPage: !!response?.nextPage,
        paginate: () => {
            return (!!response?.nextPage &&
                getMostUsedPersons({ count: null, page: response?.nextPage, minfaces, taggingEnrolled, isExplore }, logger));
        },
    };
};
